import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { Package, RenderPrintOrderRequest } from '@bringg/types';
import _noop from 'lodash/noop';
import i18next from 'i18next';
import notification from '@bringg/react-components/dist/components/notification/notification';
import { orderReceiptPrintingProvider } from '@bringg-frontend/order-receipt-printing';

import { registerAction } from '../../services/cross-application/cross-application';
import { PackagesActions } from '../../services/cross-application/cross-application.actions';
import PrintService from '../../services/print/print';
import { sanitizeOrderHtmlTemplateContentByFF } from 'bringg-web/features/templates-manager/utils';

export type PrintPackageType = 'zpl' | 'pdf';

class PackagesStore {
	constructor() {
		this.initPackagePrintListener();
	}

	async getAllTaskPackages(taskId: number): Promise<Package[]> {
		return getRootEnv().dashboardSdk.sdk.packageApi.getAllTaskPackages({ task_id: taskId });
	}

	initPackagePrintListener() {
		registerAction(
			PackagesActions.PRINT_LABEL_REQUEST,
			(params: { taskIds?: number[]; type?: PrintPackageType }) => {
				if (!params) return;

				const { taskIds = [], type = 'zpl' } = params;
				const promises = taskIds.map(async id => this.getAllTaskPackages(id));

				Promise.all(promises).then(
					results => PrintService.printLabelsFromPackages(results.flat(), type),
					_noop
				);
			},
			getRootEnv().dashboardSdk.sdk.crossAppTransport
		);

		registerAction(
			PackagesActions.PRINT_RECEIPT_API_REQUEST,
			async (params: RenderPrintOrderRequest) => {
				if (!params) return;

				try {
					await orderReceiptPrintingProvider.printReceipt(params, sanitizeOrderHtmlTemplateContentByFF);
				} catch (error) {
					console.error('failed to print receipt', error);
					notification.error(i18next.t('ORDER.FAILED_TO_PRINT_RECEIPT'));
				}
			},
			getRootEnv().dashboardSdk.sdk.crossAppTransport
		);
	}

	printPackageLabel(taskId: number, type: PrintPackageType) {
		this.getAllTaskPackages(taskId).then(packages => PrintService.printLabelsFromPackages(packages, type), _noop);
	}
}

export default PackagesStore;
